/**
 * Date-extensions locale Czech [cs]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('cs', {
    monthNames: ['Leden','únor','Březen','Duben','Květen','červen','červenec','Srpen','Září','říjen','Listopad','Prosinec'],
    monthShortNames: ['Led','úno','Bře','Dub','Kvě','čvn','čvc','Srp','Zář','říj','Lis','Pro'],
    dayNames: ['Neděle','Pondělí','úterý','Středa','čtvrtek','Pátek','Sobota'],
    dayShortNames: ['Ne','Po','út','St','čt','Pá','So']
});
